<template>
    <div>
        {{ useCase || '-' }}
    </div>
</template>

<script>
import { compliance_mixin } from '../../../mixins'

export default {
    name: 'UseCaseColumn',
    mixins: [compliance_mixin],
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        useCase() {
            return this.fixToUcFirst(this.row?.use_case)
        },
    },
}
</script>
